
<!-- Sidebar Overlay -->
@if (config.show && config.showOverlay !== false) {
  <div
    [class]="overlayClasses"
    (click)="onOverlayClick()"
    [@fadeIn]>
  </div>
}

<!-- Sidebar -->
@if (config.show) {
  <div
    [class]="sidebarClasses"
    [style.width]="sidebarWidth"
    [style.max-width]="sidebarMaxWidth"
    [@slideInFromRight]="animationParams">
    <!-- Header -->
    <div [class]="headerClasses">
      <div class="sidebar-title">
        <mat-icon class="form-icon">{{ config.icon }}</mat-icon>
        <div class="title-content">
          <h2>{{ config.title }}</h2>
          @if (config.subtitle) {
            <p class="subtitle">{{ config.subtitle }}</p>
          }
        </div>
      </div>
      <button
        mat-icon-button
        (click)="onClose()"
        class="close-sidebar-btn"
        [attr.aria-label]="'Close ' + config.title">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <!-- Content -->
    <div [class]="contentClasses">
      <ng-content></ng-content>
    </div>
    <!-- Loading Overlay for Sidebar -->
    @if (config.loading) {
      <div class="sidebar-loading-overlay">
        <mat-spinner diameter="40"></mat-spinner>
        @if (config.loadingText) {
          <p class="loading-text">{{ config.loadingText }}</p>
        }
      </div>
    }
    <!-- Footer -->
    @if (hasActions) {
      <div [class]="footerClasses">
        <div class="sidebar-actions">
          <!-- Left Actions (e.g., Delete button) -->
          @if (config.actions?.leftActions?.length) {
            <div class="left-actions">
              @for (action of config.actions.leftActions; track action; let i = $index) {
                @if (action.type === 'flat') {
                  <button
                    mat-flat-button
                    [color]="getButtonColor(action)"
                    [disabled]="action.disabled || config.loading"
                    (click)="onLeftActionClick(i)"
                    class="action-btn">
                    @if (action.icon) {
                      <mat-icon>{{ action.icon }}</mat-icon>
                    }
                    <span>{{ action.label }}</span>
                    @if (action.loading) {
                      <mat-spinner diameter="16"></mat-spinner>
                    }
                  </button>
                }
                @if (action.type === 'raised') {
                  <button
                    mat-raised-button
                    [color]="getButtonColor(action)"
                    [disabled]="action.disabled || config.loading"
                    (click)="onLeftActionClick(i)"
                    class="action-btn">
                    @if (action.icon) {
                      <mat-icon>{{ action.icon }}</mat-icon>
                    }
                    <span>{{ action.label }}</span>
                    @if (action.loading) {
                      <mat-spinner diameter="16"></mat-spinner>
                    }
                  </button>
                }
                @if (action.type === 'stroked') {
                  <button
                    mat-stroked-button
                    [color]="getButtonColor(action)"
                    [disabled]="action.disabled || config.loading"
                    (click)="onLeftActionClick(i)"
                    class="action-btn">
                    @if (action.icon) {
                      <mat-icon>{{ action.icon }}</mat-icon>
                    }
                    <span>{{ action.label }}</span>
                    @if (action.loading) {
                      <mat-spinner diameter="16"></mat-spinner>
                    }
                  </button>
                }
                @if (!action.type || action.type === 'basic') {
                  <button
                    mat-button
                    [color]="getButtonColor(action)"
                    [disabled]="action.disabled || config.loading"
                    (click)="onLeftActionClick(i)"
                    class="action-btn">
                    @if (action.icon) {
                      <mat-icon>{{ action.icon }}</mat-icon>
                    }
                    <span>{{ action.label }}</span>
                    @if (action.loading) {
                      <mat-spinner diameter="16"></mat-spinner>
                    }
                  </button>
                }
              }
            </div>
          }
          <!-- Right Actions (Primary and Secondary) -->
          <div class="right-actions">
            <!-- Secondary Actions -->
            @if (config.actions?.secondary?.length) {
              @for (action of config.actions.secondary; track action; let i = $index) {
                @if (action.type === 'flat') {
                  <button
                    mat-flat-button
                    [color]="getButtonColor(action)"
                    [disabled]="action.disabled || config.loading"
                    (click)="onSecondaryActionClick(i)"
                    class="action-btn secondary-btn">
                    @if (action.icon) {
                      <mat-icon>{{ action.icon }}</mat-icon>
                    }
                    <span>{{ action.label }}</span>
                    @if (action.loading) {
                      <mat-spinner diameter="16"></mat-spinner>
                    }
                  </button>
                }
                @if (action.type === 'raised') {
                  <button
                    mat-raised-button
                    [color]="getButtonColor(action)"
                    [disabled]="action.disabled || config.loading"
                    (click)="onSecondaryActionClick(i)"
                    class="action-btn secondary-btn">
                    @if (action.icon) {
                      <mat-icon>{{ action.icon }}</mat-icon>
                    }
                    <span>{{ action.label }}</span>
                    @if (action.loading) {
                      <mat-spinner diameter="16"></mat-spinner>
                    }
                  </button>
                }
                @if (action.type === 'stroked') {
                  <button
                    mat-stroked-button
                    [color]="getButtonColor(action)"
                    [disabled]="action.disabled || config.loading"
                    (click)="onSecondaryActionClick(i)"
                    class="action-btn secondary-btn">
                    @if (action.icon) {
                      <mat-icon>{{ action.icon }}</mat-icon>
                    }
                    <span>{{ action.label }}</span>
                    @if (action.loading) {
                      <mat-spinner diameter="16"></mat-spinner>
                    }
                  </button>
                }
                @if (!action.type || action.type === 'basic') {
                  <button
                    mat-button
                    [color]="getButtonColor(action)"
                    [disabled]="action.disabled || config.loading"
                    (click)="onSecondaryActionClick(i)"
                    class="action-btn secondary-btn">
                    @if (action.icon) {
                      <mat-icon>{{ action.icon }}</mat-icon>
                    }
                    <span>{{ action.label }}</span>
                    @if (action.loading) {
                      <mat-spinner diameter="16"></mat-spinner>
                    }
                  </button>
                }
              }
            }
            <!-- Primary Action -->
            @if (config.actions?.primary) {
              @if (config.actions.primary.type === 'flat') {
                <button
                  mat-flat-button
                  [color]="getButtonColor(config.actions.primary)"
                  [disabled]="config.actions.primary.disabled || config.loading"
                  (click)="onPrimaryActionClick()"
                  class="action-btn primary-btn">
                  @if (config.actions.primary.icon) {
                    <mat-icon>{{ config.actions.primary.icon }}</mat-icon>
                  }
                  <span>{{ config.actions.primary.label }}</span>
                  @if (config.actions.primary.loading) {
                    <mat-spinner diameter="16"></mat-spinner>
                  }
                </button>
              }
              @if (config.actions.primary.type === 'raised') {
                <button
                  mat-raised-button
                  [color]="getButtonColor(config.actions.primary)"
                  [disabled]="config.actions.primary.disabled || config.loading"
                  (click)="onPrimaryActionClick()"
                  class="action-btn primary-btn">
                  @if (config.actions.primary.icon) {
                    <mat-icon>{{ config.actions.primary.icon }}</mat-icon>
                  }
                  <span>{{ config.actions.primary.label }}</span>
                  @if (config.actions.primary.loading) {
                    <mat-spinner diameter="16"></mat-spinner>
                  }
                </button>
              }
              @if (config.actions.primary.type === 'stroked') {
                <button
                  mat-stroked-button
                  [color]="getButtonColor(config.actions.primary)"
                  [disabled]="config.actions.primary.disabled || config.loading"
                  (click)="onPrimaryActionClick()"
                  class="action-btn primary-btn">
                  @if (config.actions.primary.icon) {
                    <mat-icon>{{ config.actions.primary.icon }}</mat-icon>
                  }
                  <span>{{ config.actions.primary.label }}</span>
                  @if (config.actions.primary.loading) {
                    <mat-spinner diameter="16"></mat-spinner>
                  }
                </button>
              }
              @if (!config.actions.primary.type || config.actions.primary.type === 'basic') {
                <button
                  mat-button
                  [color]="getButtonColor(config.actions.primary)"
                  [disabled]="config.actions.primary.disabled || config.loading"
                  (click)="onPrimaryActionClick()"
                  class="action-btn primary-btn">
                  @if (config.actions.primary.icon) {
                    <mat-icon>{{ config.actions.primary.icon }}</mat-icon>
                  }
                  <span>{{ config.actions.primary.label }}</span>
                  @if (config.actions.primary.loading) {
                    <mat-spinner diameter="16"></mat-spinner>
                  }
                </button>
              }
            }
          </div>
        </div>
      </div>
    }
  </div>
}
